import * as React from "react";
import type { ReactNode } from "react";
import type { Menu, MenuCategory, MenuItemCategory, MenuItemHr, Variant } from "./type";

export interface AbstractMenuProps {
	variant: Variant;
}

export interface AbstractMenuState {
	variant: Variant;
	openedMenu?: MenuItemCategory;
	openedSubMenu?: MenuItemCategory;
	openedSubMenuLevel2?: MenuItemCategory;
}

export abstract class AbstractMenu<
	Props extends AbstractMenuProps = AbstractMenuProps,
	State extends AbstractMenuState = AbstractMenuState,
> extends React.Component<Props, State> {
	protected lastOpenedLevel: MenuCategory = undefined;

	constructor(props: Props) {
		super(props);
		const { variant } = props;
		this.state = {
			variant,
			openedMenu: undefined,
			openedSubMenu: undefined,
			openedSubMenuLevel2: undefined,
		} as State;
	}

	public abstract render(): ReactNode;
	protected abstract renderLevelItem(item: Menu, key: number, menuCategory?: MenuCategory): ReactNode;

	protected isHrMenuItem(item: Menu): item is MenuItemHr {
		return (item as MenuItemHr).isHr === true;
	}

	protected isCategoryMenuItem(item: Menu): item is MenuItemCategory {
		return !!(item as MenuItemCategory).items;
	}

	protected onSelectSubmenu(item: MenuItemCategory | undefined, menuCategory: MenuCategory): void {
		switch (menuCategory) {
			case "main":
				this.changeOpenedMenu(item);
				break;
			case "primary":
				this.changeOpenedSubMenu(item);
				break;
			case "sub-menu":
				this.changeOpenedSubMenuLevel2(item);
				break;
			default:
		}
	}

	protected changeOpenedMenu(menu: MenuItemCategory | undefined): void {
		this.lastOpenedLevel = "main";
		this.setState({
			openedMenu: menu,
			openedSubMenu: undefined,
			openedSubMenuLevel2: undefined,
		});
	}

	protected changeOpenedSubMenu(menu: MenuItemCategory | undefined): void {
		const { openedSubMenu, openedSubMenuLevel2 } = this.state;

		if ((!menu && openedSubMenu) || openedSubMenuLevel2 || openedSubMenu?.title !== menu?.title) {
			this.lastOpenedLevel = "primary";
			this.setState({
				openedSubMenu: menu,
				openedSubMenuLevel2: undefined,
			});
		}
	}

	protected changeOpenedSubMenuLevel2(menu: MenuItemCategory | undefined): void {
		const { openedSubMenuLevel2 } = this.state;

		if ((!menu && openedSubMenuLevel2) || openedSubMenuLevel2?.title !== menu?.title) {
			this.lastOpenedLevel = "sub-menu";
			this.setState({
				openedSubMenuLevel2: menu,
			});
		}
	}
}
